import React from 'react';

import { cn } from '@change/ds-utils';

import { Separator } from '@change/ds-core-ui/next';

import { Circle, Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { RectangleShapeStyles, SkeletonContainerStyles } from './Header.styles';
import { GroupHeaderStyles, GroupImageStyles, GroupNameStyles } from './HeaderGroup.styles';
import { TextSkeleton1Styles, TextSkeleton2Styles, TextSkeletonContainerStyles } from './HeaderTextSkeletons.styles';
import type { FacebookGroupPostComponentsProps } from './types';

export function Header(props: FacebookGroupPostComponentsProps): React.JSX.Element {
	const { loading, size, recommendedGroup: { name: groupName = '', metadata: { imageUrl } = {} } = {} } = props;

	const rectangleStyles = RectangleShapeStyles({ size });

	return (
		<div>
			{loading && (
				<SkeletonContainer loading={loading} shapeSize={size} className={GroupHeaderStyles({ size })}>
					<Circle data-testid="circle" className={GroupImageStyles({ size })} />
					<div className={TextSkeletonContainerStyles({ size })}>
						<Rectangle className={cn(rectangleStyles, TextSkeleton1Styles({ size }))} rounded data-testid="rectangle" />
						<Rectangle className={cn(rectangleStyles, TextSkeleton2Styles({ size }))} rounded data-testid="rectangle" />
					</div>
				</SkeletonContainer>
			)}
			{!loading && (
				<div className={GroupHeaderStyles({ size })}>
					<div className={GroupImageStyles({ size })}>
						<img src={imageUrl || undefined} aria-hidden alt="" className="h-full w-full object-cover" />
					</div>
					<p className={GroupNameStyles({ size })}>{groupName}</p>
				</div>
			)}
			<Separator className="m-0 p-0" />
			<SkeletonContainer
				loading={loading}
				shapeSize={size}
				className={SkeletonContainerStyles({ size })}
				data-testid="skeleton-container"
			>
				<Circle data-testid="circle" />
				<div className={TextSkeletonContainerStyles({ size })}>
					<Rectangle className={cn(rectangleStyles, TextSkeleton1Styles({ size }))} rounded data-testid="rectangle" />
					<Rectangle className={cn(rectangleStyles, TextSkeleton2Styles({ size }))} rounded data-testid="rectangle" />
				</div>
			</SkeletonContainer>
		</div>
	);
}
